import script from "./CongratulationModal.vue?vue&type=script&setup=true&lang=js"
export * from "./CongratulationModal.vue?vue&type=script&setup=true&lang=js"

import "./CongratulationModal.vue?vue&type=style&index=0&id=35bfee80&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-35bfee80"]])

export default __exports__